import { BLOCK_REGISTRY } from "../blockRegistry";

const HELP_CENTER_DEFAULT_BLOCKS = [
  {
    id: "default-help-hero",
    type: "about-hero",
    fields: {
      ...BLOCK_REGISTRY["about-hero"].defaultFields,
      eyebrow: "Support",
      headline: "How can we help?",
      subtext: "Find answers about your bookings, or get in touch with our team.",
    },
  },
  {
    id: "default-help-topics",
    type: "generic-link-cards",
    fields: {
      eyebrow: "",
      headline: "",
      items: [
        { icon: "CircleHelp", title: "FAQs", description: "Quick answers to common questions about booking with Exqura.", linkLabel: "Read FAQs", href: "/faqs" },
        { icon: "Flag", title: "My Bookings", description: "View your upcoming and past bookings.", linkLabel: "View bookings", href: "/my-bookings" },
        { icon: "CalendarCheck", title: "Cancellations & Refunds", description: "How cancelling works and when refunds are processed.", linkLabel: "See the policy", href: "/cancellation-policy" },
        { icon: "Headphones", title: "Contact Us", description: "Can't find what you need? Our team is happy to help.", linkLabel: "Get in touch", href: "/ContactUs" },
      ],
    },
  },
];

export default HELP_CENTER_DEFAULT_BLOCKS;
